<template>
  <div class="scroll-wrapper" :class="{ sand: background === 'sand' }">
    <div class="top" :class="{ 'hidden-block': !showTopFade }"></div>
    <div class="scroll" :class="{ 'hidden-scrollbar': hideScrollbar }" @scroll="checkScroll" ref="scrollContent">
      <slot />
    </div>
    <div class="bottom" :class="{ 'hidden-block': !showBottomFade }"></div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NScroller extends Vue {
  @Prop({ type: String, default: 'white' }) background!: 'white' | 'sand'
  @Prop({ type: Boolean, default: false }) hideScrollbar!: boolean
  showTopFade: boolean = false
  showBottomFade: boolean = false

  checkScroll() {
    const scrollContent = this.$refs.scrollContent as HTMLElement
    this.showTopFade = scrollContent.scrollTop > 0
    this.showBottomFade = scrollContent.scrollTop + scrollContent.clientHeight < scrollContent.scrollHeight
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.scroll-wrapper {
  position: relative;
  height: 100%;
  overflow: hidden;

  .scroll {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .top,
  .bottom {
    height: $notch-space-10x;
    width: 100%;
    position: absolute;
    left: 0;
    z-index: $notch-layer-1;
    pointer-events: none;
  }

  .top {
    top: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
  }

  .bottom {
    bottom: 0;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 100%);
  }

  &.sand {
    .top {
      background: linear-gradient(to bottom, $notch-color-neutral-sand-50 0%, rgba(255, 255, 255, 0) 100%);
    }

    .bottom {
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, $notch-color-neutral-sand-50 100%);
    }
  }

  .hidden-block {
    display: none;
  }

  .hidden-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
